import { createSelector } from 'reselect';

import { selectGetConfigValue } from '@pressreader/config';

import { SEO_TOPIC_LEGACY_ROUTE_DISABLED_CONFIG_KEY, SEO_TOPIC_ROUTE_CONFIG_KEY } from '../constants';

/** Gates the "/topics/{slug}-{id}" SEO topic route and slug-shaped tag link generation (PBI 175285). */
export const selectSeoTopicRouteEnabled = createSelector(selectGetConfigValue, (getConfigValue): boolean =>
    getConfigValue(SEO_TOPIC_ROUTE_CONFIG_KEY, false),
);

/** See {@link SEO_TOPIC_LEGACY_ROUTE_DISABLED_CONFIG_KEY}. */
export const selectLegacyTagRouteDisabled = createSelector(selectGetConfigValue, (getConfigValue): boolean =>
    getConfigValue(SEO_TOPIC_LEGACY_ROUTE_DISABLED_CONFIG_KEY, false),
);
